import React, { createRef, useEffect, useState } from "react";
import { Space, Button, Form, Col, Row, Input, DatePicker, Select } from "antd";
import { CardBody } from "reactstrap";
import { Image, H5 } from "../../../../AbstractElements";
import axios from "axios";
import { CurrencyApi, OrganisationProfileAPI } from "../../../../api";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { useRef } from "react";
import { UserOutlined } from "@ant-design/icons";
import {
  downloadPoBudgetData,
  fetchOrganisationDetails,
} from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import {
  organisationEditGranted,
  organisationViewGranted,
} from "../../../../utils/PermissionFunctions/userPermissions";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const OrganisationProfile = (props) => {
  const logger = React.useContext(LoggerContext);

  const { user } = props.settings;
  console.log(user, "props");
  const formRef = useRef();
  const imgInputRef = useRef();
  const { Option } = Select;
  const currentDate = new Date();
  const [initials, setInitials] = useState(
    currentDate.getFullYear().toString()
  );
  const [poInitials, setPoInitials] = useState(
    currentDate.getFullYear().toString()
  );
  const [currency, setCurrency] = useState([]);
  const [po_counter, setPoCounter] = useState(0);
  const [projectCodeInitials, setProjectCodeInitials] = useState("");
  const [poNumberInitials, setPoNumberInitials] = useState("");
  const [organisationLogo, setOrganisationLogo] = useState();
  const [updateOrganisationLogo, setUpdateOrganisationLogo] = useState();
  const [image, setImage] = useState();
  const [unsaved, setUnsaved] = useState(false);

  useEffect(() => {
    fetchCurrency();
  }, []);
  useEffect(() => {}, [poNumberInitials]);
  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      formRef?.current?.setFieldsValue({
        name: res?.name,
        short_name: res?.short_name ?? "",
        pan_number: res?.pan_number ?? "",
        address: res?.address ?? "",
        currency: res?.currency ?? 1,
        city: res?.city ?? "",
        project_code_initials: res?.project_code_initials ?? "",
        po_number_initials: res?.po_number_initials ?? "",
        pincode: res?.pincode ?? "",
      });
      setInitials(res?.project_code_format);
      setPoCounter(res?.po_counter);
      setPoInitials(res?.po_number_format ?? "YYYY");
      setProjectCodeInitials(res?.project_code_initials ?? "PRO");
      setPoNumberInitials(res?.po_number_initials ?? "PO");
      setImage(res?.organisation_logo);
      setOrganisationLogo(res?.organisation_logo);
    });
  };
  const fetchCurrency = () => [
    axios.get(`${CurrencyApi}`).then((res) => {
      setCurrency(res?.data);
    }),
  ];

  useEffect(() => {
    if (formRef.current !== null) {
      getOrganisationDetails();
    }
  }, [formRef]);

  useEffect(() => {}, [poInitials, initials]);

  // const [nameError, setNameError] = useState(false)
  // const [panError, setPanError] = useState(false)
  // const [cityError, setCityError] = useState(false)
  // const [pinError, setPinError] = useState(false)

  const saveChanges = () => {
    if (organisationEditGranted(props.settings?.user)) {
      const updatedValues = formRef.current.getFieldsValue();
      console.log("updatedValues",updatedValues)
      if (updatedValues.name?.length > 0) {
        const values = new FormData();
        values.append("name", updatedValues.name);
        values.append("short_name", updatedValues.short_name ?? "");
        values.append("pan_number", updatedValues.pan_number ?? "");
        values.append("city", updatedValues.city ?? "");
        values.append("address", updatedValues.address ?? "");
        values.append("currency", updatedValues.currency ?? 1);
        values.append("project_code_initials", projectCodeInitials ?? "");
        values.append("po_number_initials", poNumberInitials ?? "");
        values.append("project_code_format", initials ?? "YYYY");
        values.append("po_number_format", poInitials ?? "YYYY");

        values.append("pincode", updatedValues.pincode);
        if (updateOrganisationLogo) {
          values.append("organisation_logo", updateOrganisationLogo);
        }
        axios
          .put(`${OrganisationProfileAPI}`, values)
          .then((res) => {
            toast.success("Changes Saved!");
            getOrganisationDetails();
            setUnsaved(false);
          })
          .catch((res) => {});
      } else {
        console.log(projectCodeInitials);
        console.log(poNumberInitials);
        console.log(currency);
        toast.error("Enter all fields!");
      }
    } else {
      toast.info("You do not have the access to perform this action.");
    }
    logger.log(LogEvents.saveOrganizationChanges, {});
  };
  const initalOptions = [
    {
      label: "YYYY",
      value: currentDate.getFullYear().toString(),
    },
    {
      label: "MM-YYYY",
      value:
        (currentDate.getMonth() + 1 <= 9
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1) +
        "-" +
        currentDate.getFullYear(),
    },
    {
      label: "YYYYYY",
      value:
        currentDate.getFullYear().toString() +
        currentDate.getFullYear().toString().substring(2),
    },
    {
      label: "MM-YY",
      value:
        (currentDate.getMonth() + 1 <= 9
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1) +
        "-" +
        currentDate.getFullYear().toString().substring(2),
    },
    {
      label: "YY",
      value: currentDate.getFullYear().toString().substring(2),
    },
  ];
  const selectInitials = (
    <Select
      defaultValue={"YYYY"}
      onChange={(e) => {
        setInitials(e);
      }}
    >
      {initalOptions.map((each, i) => (
        <Option key={i} value={each.label}>
          {each.label}
        </Option>
      ))}
    </Select>
  );
  const selectPoInitials = (
    <Select
      defaultValue={"YYYY"}
      value={poInitials}
      onChange={(e) => {
        setPoInitials(e);
      }}
    >
      {initalOptions.map((each, i) => (
        <Option key={i} value={each.label}>
          {each.label}
        </Option>
      ))}
    </Select>
  );

  const currencyOptions = currency?.map((each) => (
    <Option key={each?.id} value={each?.id}>
      {each?.name} | {each?.symbol}
    </Option>
  ));

  const getExampleDateFrom = ({ format }) => {
    const date = initalOptions.find((option) => {
      return option.label == format;
    });
    return date?.value;
  };

  useEffect(() => {}, [formRef]);
  const downloadAllPOItemData = () => {
    logger.log(LogEvents.downloadAllPoWoData, {});
    if (organisationEditGranted(props.settings?.user)) {
      downloadPoBudgetData({ branch: props?.settings?.branch?.id });
    } else {
      toast.info("You do not have the access to perform this action.");
    }
  };

  useEffect(() => {
    if (updateOrganisationLogo) {
      // Convert file to blob URL
      // and store it in image
      const objectURL = URL.createObjectURL(updateOrganisationLogo);
      setImage(objectURL);
      setUnsaved(true);

      console.log("image", objectURL, image);
    }
  }, [updateOrganisationLogo]);

  return (
    <React.Fragment>
      <CardBody>
        <H5>Organisation Details</H5>
        <div className="d-flex" style={{ alignItems: "center" }}>
          {image ? (
            <Image
              attrImage={{
                className: "img-100 rounded-circle",
                alt: "",
                src: `${image}`,
                style: { cursor: "pointer" },
                onClick: () => {
                  if (imgInputRef.current) {
                    imgInputRef.current.click();
                  }
                },
              }}
            />
          ) : (
            <div
              className="img-100 rounded-circle"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #000",
                cursor: "pointer",
              }}
              onClick={() => {
                if (imgInputRef.current) {
                  imgInputRef.current.click();
                }
              }}
            >
              <UserOutlined style={{ fontSize: "60px" }} />
            </div>
          )}
          <input
            type="file"
            accept="image/jpg,image/jpeg,image/png"
            onChange={(e) => {
              setUpdateOrganisationLogo(e.target.files[0]);
            }}
            style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
            ref={imgInputRef}
          />
          {unsaved && <span style={{ color: "red" }}>Unsaved changes.</span>}
        </div>
        <Form
          layout="vertical"
          id="organisationProfileForm"
          ref={formRef}
          onFinish={saveChanges}
        >
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"name"}
                label="Name"
                rules={[
                  {
                    required: true,
                    message: "Name is required",
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
            </Col>

            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                    message: "Enter valid City",
                  },
                ]}
              >
                <Input placeholder="Enter city" />
              </Form.Item>
            </Col>
            {/* <Col sm={12}>
              <Form.Item name={"short_name"} label="Short Name">
                <Input placeholder="Enter short name" />
              </Form.Item>
            </Col> */}
          </Row>
          {/* <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"pan_number"}
                label="Pan Number"
                rules={[
                  {
                    pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                    message: "Enter pan card number correctly",
                  },
                ]}
              >
                <Input placeholder="Enter Pan Number" />
              </Form.Item>
            </Col>
          </Row> */}
          {/* <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"address"} label="Address">
                <Input placeholder="Enter Address" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    pattern: /^[0-9]{6}$/,
                    message: "Enter a valid six digit pin code",
                  },
                ]}
              >
                <Input placeholder="Enter Pincode" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"project_code_initials"}
                label={`Project Code Initials: (${projectCodeInitials ?? ""}-
                ${getExampleDateFrom({ format: initials })})`}
                rules={[
                  {
                    required: true,
                    message: "Project code is required",
                  },
                ]}
              >
                <Input
                  addonAfter={selectInitials}
                  defaultValue={projectCodeInitials}
                  onChange={(e) => {
                    setProjectCodeInitials(e.target.value);
                  }}
                  value={projectCodeInitials}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"po_number_initials"}
                label={`PO Number Initials: (${
                  poNumberInitials ?? "" + "-"
                }${getExampleDateFrom({ format: poInitials })}${
                  "-" + po_counter ?? 0
                })`}
                rules={[
                  {
                    required: true,
                    message: "Project Number is required",
                  },
                ]}
              >
                <Input
                  value={poNumberInitials}
                  addonAfter={selectPoInitials}
                  onChange={(e) => {
                    setPoNumberInitials(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"currency"} label="Currency" required="true">
                <Select placeholder="Select Currency">{currencyOptions}</Select>
              </Form.Item>
            </Col>
          </Row> */}

          <Row gutter={24}>
            <Col>
              <Space className="mb-0">
                <Button
                  htmlType="submit"
                  form="organisationProfileForm"
                  // onClick={saveChanges}
                >
                  {"Save Changes"}
                </Button>
                {/* <Button
                  onClick={() => {
                    setPoNumberInitials(0);
                  }}
                >
                  {"Reset PO Number to zero"}
                </Button> */}
                <Button
                  onClick={() => {
                    downloadAllPOItemData();
                  }}
                >
                  {"Download all Po/Wo data"}
                </Button>
                {/* <Button
                  onClick={() => {
                    setProjectCodeInitials(0);
                  }}
                >
                  {"Reset All Project Codes"}
                </Button> */}
              </Space>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(OrganisationProfile);
